export enum TourOperator {
  APOLLO = 'apollo',
  TJAREBORG = 'tjareborg',
  ALPPIMATKAT = 'alppimatkat',
  TOIVIOMATKAT = 'toiviomatkat',
  MIXXTRAVEL = 'mixxtravel',
}
